import React from "react";
import { CircularProgress, Backdrop, Typography, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.modal + 1,
        color: "#fff",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
    content: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    message: {
        marginTop: theme.spacing(2),
        fontSize: "1.2rem",
        fontWeight: 500,
    },
}));

export default function LoadingOverlay({ isLoading, message }) {
    const classes = useStyles();

    if (!isLoading) {
        return null;
    }

    return (
        <Backdrop className={classes.backdrop} open={isLoading}>
            <Box className={classes.content}>
                <CircularProgress color="inherit" size={60} />
                {message && (
                    <Typography className={classes.message}>{message}</Typography>
                )}
            </Box>
        </Backdrop>
    );
}
